module.exports = __webpack_public_path__ + "static/img/06.c666311.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/06.jpg
// module id = 428
// module chunks = 1